export { default as HeadTitle } from './HeadTitle';
